module.exports = __webpack_public_path__ + "img/card_savantPlan.927608ef.png";